import { ref } from 'vue';
import { useEndpoint } from './useEndpoint';
import { useUtilities } from './useUtilities';
import { MarketSchema } from '@apparatix/schemas/AccountDetail';
import { MarketsResponse } from '@apparatix/types/Account';

export const useMarkets = () => {
  const markets = ref<Array<Required<MarketSchema>>>([]);
  const placeholder = ref('Loading...');

  const { arrayHasValues } = useUtilities();

  const { isLoading, makeRequest } = useEndpoint<MarketsResponse>({
    url: '/crm/accounts/markets',
    type: 'GET',
    successField: 'data',
    startInLoadingState: true,
    onSuccess: response => {
      if (arrayHasValues(response.data.markets)) {
        markets.value = response.data.markets satisfies MarketSchema[];
        placeholder.value = 'Select Markets';
      } else {
        placeholder.value = 'Error loading Markets';
      }
    },
    onError: () => {
      placeholder.value = 'Error loading Markets';
    },
    toast: {
      showOnSuccess: false,
    },
  });

  makeRequest();

  return {
    isLoading,
    markets,
    placeholder,
  };
};
